export default __webpack_public_path__ + "static/rowntree-caveat-background-d2af1faf91e0fc7a9412ce2893163eec.webp";